import axios from "axios";
import { readCache, writeCache } from "./offlineCache";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ch_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Send the caller's app language so backend GETs can substitute
  // translated versions of announcements, events, sermons, prayers,
  // pastor/first-elder bios, and the church About description.
  const lang = localStorage.getItem("ch_lang") || "en";
  config.headers["X-App-Language"] = lang;
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Opt-in offline cache. Any GET called with `{ cache: true }` gets its
    // response body stored so we can serve it on the next network error.
    // Non-GETs and un-flagged calls are untouched.
    try {
      if (
        r?.config?.cache &&
        (r.config.method || "get").toLowerCase() === "get" &&
        r.status >= 200 && r.status < 300
      ) {
        writeCache(r.config.url, r.config.params, r.data);
      }
    } catch {
      /* cache write must never break a response */
    }
    return r;
  },
  (err) => {
    // On network / timeout / 5xx errors, try to satisfy `{ cache: true }`
    // GETs from the previously cached body so read-only pages keep working
    // offline. Only fall through to cache when the request explicitly
    // opted in — public/anonymous callers won't accidentally see stale
    // authenticated data.
    try {
      const cfg = err?.config;
      const looksOffline =
        !err?.response ||
        err.code === "ERR_NETWORK" ||
        err.code === "ECONNABORTED" ||
        (err.response && err.response.status >= 500);
      if (
        cfg?.cache &&
        (cfg.method || "get").toLowerCase() === "get" &&
        looksOffline
      ) {
        const data = readCache(cfg.url, cfg.params);
        if (data != null) {
          return Promise.resolve({
            data,
            status: 200,
            statusText: "OK (from offline cache)",
            headers: {},
            config: cfg,
            fromCache: true,
          });
        }
      }
    } catch {
      /* fall through to reject */
    }
    if (err?.response?.status === 401) {
      // do not auto-logout to allow retries on public endpoints
    }
    return Promise.reject(err);
  }
);
